(function (fox, $, undefined) {
	'use strict';

	fox.registerWidget('Content_TagsFilter', {
		configure: function () {
			this.tagsList = [];
			this.currentTag = null;
			this.tagListLoaded = false;
			this._isOpened = false;
			this.pagination = {
				limit: 5,
				offset: 0,
			},
			this.registerOptions('', {
				preset: false,
				closeOnClick: true,

				widgets: {
					tagsApi: {
						widget: 'Api',
						method: 'Content_Tag.getAllTags',
						cacheChannel: 'content',
					},

					searchApi: {
						widget: 'Api',
						method: 'Content_Tag.searchTags',
						cacheChannel: 'content', 
					},

					selectGrid: {
						widget: 'Widget',
						embed: {
							widget: '@parent @parent',
							container: '.tags-filter'
						},
						
						template: 'tags_filter',
						autoRender: true,

						widgets: {
							current: {
								widget: 'Widget',
								container: '.current',
								template: 'tags_filter_current',
								templateOptions: {alias: fox.Navigator.get('tags') || 'all tags'},
								autoRender: true
							},
							search: {
								widget: 'Widget',
								container: '.tags-search',
								template: 'tags_filter_search',
								autoRender: true
							},
							list: {
								widget: 'AdvancedList',
								notOverrideListBehavior: 1,
								container: '.tags-list',
								tpl: {
									row: 'tags_filter_row'
								},
								'handleDom.onclick':{
									target: '.tag',
									event: 'click',
									callback: (...args) => this._handleTagClick(...args)
								},
								'hooks.onAddedToDom': () => this.applyScrollbar()
							}
						}
					}
				},

				handleWom: {
					tagsLoaded: {
						widget: '#tagsApi',
						event: 'success',
						callback: '_handleTagsLoad'
					},
					searchLoaded: {
						widget: '#searchApi',
						event: 'success',
						callback: '_handleSearchLoad'
					}
				},

				handleDom: {
					
					search: {
						targetWidget: '#selectGrid #search',
						target: '[name="tag-search"]',
						event: 'input',
						callback: '_search'
					},

					focus: {
						targetWidget: '#selectGrid #search',
						target: '[name="tag-search"]',
						event: 'click',
						callback: function (el, alias, w, e) {
							fox.dom.event.stop(e);
						}
					},

					openList: {
						targetWidget: '#selectGrid',
						target: '.click-to-open',
						event: 'click',
						callback: (...args) => this.toggleList(...args)
					},

					preventClick: {
						targetWidget: '#selectGrid',
						target: '.tags-list-wrapper',
						event: 'touchstart',
						callback: function (el, alias, w, e) {
							var res = e.stopPropagation ? e.stopPropagation() : e.cancelBubble = true;
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function (argument) {
			this.tagsApi = this.rwom1('#tagsApi');
			this.searchApi = this.rwom1('#searchApi');
			this.grid = this.rwom1('#selectGrid');
			this.list = this.grid.rwom1('#list');
			this.current = this.grid.rwom1('#current');
			$(document).on('click touchstart', {widget: this}, this._close);
			
			this.getTags();

			this.callParent('running', arguments);
		},

		activate: function () {
			this.getTags();

			$(document).on('click touchstart', {widget: this}, this._close);

			this.pagination.offset = 0;
			this.callParent('activate', arguments);
		},

		deactivate: function () {
			this.grid._readyToRender = false;
			this.grid.removeFromDom();

			$(window).off('click touchstart', this._close);

			this.callParent('deactivate', arguments);
		},

		getTags: function () {
			this.setPaginationMethod('getTags');
			let params = {
				preset: this.getOption('preset'),
				limit: this.pagination.limit,
				offset: this.pagination.offset
			};
			this.tagsApi.send(params);
		},

		_handleTagsLoad: function (resp, api, e) {
			var response = resp.answer.response.success;
			this.nextData ? this.nextData = false : this.list.resetCollection();
			if (!fox.isEmpty(response)) {
				
				this.setTagsList(response);
			}
		},

		_handleSearchLoad: function (resp, api, e) {
			let response = resp.answer.response.success;
			this.nextData ? this.nextData = false : this.list.resetCollection();
			if (!fox.isEmpty(response)) {
				this.setTagsList(response);
			}
		},

		setTagsList: function (tags) {
			var all = {value :{
				alias: 'all tags',
				id: 'all'
			}};

			let fromNavi = tags.filter((tag) => tag.alias == this.getTagsFromNavigator());
			if (this.list.dataModel.length === 0) {
				tags.unshift(all.value);
			}
			if (!this.currentTag) {
				this.currentTag = fox.isEmpty(fromNavi) ? all : {value: fromNavi[0]};
			}

			this.renderList(tags);
			this.markSelectedTag();
		},

		renderList: function (list) {
			this.list.appendItem(list);
		},

		markSelectedTag: function () {
			this.list.dataModel.filter((tag) => tag.value.selected = (tag.value.id == this.currentTag.value.id));
			this.current.setTemplateOptions({alias: this.currentTag.value.alias}).render();
			this.list.render();
		},

		changeURI: function () {
			var navi = fox.Navigator;
			
			if (navi.get('tags') === this.currentTag.value.alias) {
				return;
			};


			if (this.currentTag.value.alias === 'all tags') {
				var hash = navi.getAll();

				if (hash['tags']) {
					delete hash['tags'];
				}

				navi.update(hash, false);

				return;
			};

			navi.set('tags', window.encodeURIComponent(this.currentTag.value.alias), false);
		},

		renderSelectGrid: function () {
			this.grid._readyToRender = false;

			this.grid.removeFromDom();
			this.currentTag = null;
		},

		
		applyScrollbar: function () {
			var el = this.rwom1('#selectGrid');
			if (!el) return;
			$(el.element[0])
				.find('.tags-scroll')
				.mCustomScrollbar({
					theme: 'light-thin',
					scrollButtons: false,
					scrollbarPosition: 'inside',
					scrollInertia: 0,
					mouseWheel: {preventDefault: true},
					callbacks: {
						onTotalScroll: function () {
							this.getNextData();
						}.bind(this)
					}
				});
		},

		_handleTagClick: function (elt) {
			let id = elt.dataset.tagid;
			fox.each(this.list.dataModel, function (tagData) {
				tagData.value.selected = false;
				if (tagData.value.id == id) {
					this.currentTag = tagData;
					throw fox.break;
				};
			}, this);

			this.selectTag(this.currentTag);
			this.hookWrapper('selectTag', this.currentTag.value);
			this.dispatchEvent('selectTag', this.currentTag.value);
		},

		selectTag: function () {
			this.markSelectedTag();
			this.changeURI();

			if (this.getOption('closeOnClick')) {
				this.renderSelectGrid();
			};
		},

		_setTag: function (tags) {
			this.hookWrapper('setTag', tags);
			this.dispatchEvent('setTag', tags);	
		},

		setTag: function (tags) {
			var tagAlias = tags.length ? tags[0] : 'all tags';

			if (!this.tagListLoaded) {
				this.currentTag = {value: {alias: tagAlias}};

				return;
			}

			fox.each(this.list.dataModel, function (tagData) {
				if (tagData.alias == tagAlias) {
					this.currentTag.value = tagData;
					fox.break;
				};
			}, this);
			console.log('setTag');
			this.markSelectedTag();
		//	this.renderSelectGrid();
		},

		setPaginationMethod: function(method) {
			if (!!this.paginationMethod && this.paginationMethod != method) {
				this.pagination = {
					limit: 5,
					offset: 0,
				}
			}
			this.paginationMethod = method;
		},

		isMobileDevice: function (argument) {
			//from Swipe.js library
			return true;
			//return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
		},

		toggleList: function (el, alias, w, e) {
			fox.dom.event.stop(e);
			if (this._isOpened) {
				this.close();

				return;
			};

			this.open();
		},

		open: function () {
			fox.dom.addClass('opened', this.grid.dom1('.tags-filter-wrapper'));
			this._isOpened = true;
		},

		close: function () {
			if (this.isOpened === false) {
				return;
			}
			
			fox.dom.removeClass('opened', this.grid.dom1('.tags-filter-wrapper'));
			this._isOpened = false;
		},


		_search: function (el) {
			var value = fox.trim(el.value);
			if (!value.length) {
				this.getTags();
				return;
			};
			if (value.length > 2) {
				this.filterByKey(value);
			}
		},

		filterByKey: function (key) {
			this.setPaginationMethod('filterByKey');
			let params = {
				preset: this.getOption('preset'),
				limit: this.pagination.limit,
				offset: this.pagination.offset,
				tagsLike: key
			};
			this.searchApi.send(params);
		},

		getTagsFromNavigator: function (argument) {
			var tags = fox.Navigator.get('tags') || [];

			return (tags.length ? window.decodeURIComponent(tags).split(',') : false);
		},
		getNextData: function() {
			this.pagination.offset = this.pagination.offset + this.pagination.limit;
			this[this.paginationMethod]();
			this.nextData = true;
		}

	}, 'Controller');

})(fox, fox.jQuery);



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/content/tagsfilter.es.js